import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../configs/firebaseConfig"; // Your Firebase config

const PrivateRoute = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // Loading state while checking auth
  const location = useLocation();
  const { companyName } = useParams();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
      } else {
        setUser(null);
      }
      setLoading(false); // Set loading to false once auth is checked
    });

    // Cleanup listener when component unmounts
    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div>Loading...</div>; // You can replace this with a spinner or loading UI
  }

  // If no user is authenticated, redirect to login
  return user ? (
    children
  ) : (
    <Navigate
      to={companyName ? `/${companyName}` : "/"}
      replace
      state={{ from: location }}
    />
  );
};

export default PrivateRoute;
